import { createSlice } from "@reduxjs/toolkit";
import { getOrganizationList, saveOrganization, deleteOrganization } from "../controller/organization.controller";
import { Organization } from "../types/organizationType";
import { SaveResponse } from "../types/common";

interface OrganizationState {
  loading: boolean;
  list: Organization[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: OrganizationState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    resetOrganizationResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrganizationList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getOrganizationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data organisasi";
      })
      .addCase(saveOrganization.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan organisasi";
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetOrganizationResponse } = organizationSlice.actions;
export default organizationSlice.reducer;
